const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a`, `89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a`, 1, 26), new Map([[`tag_name`, `aside`], [`class`, `c-card--contained c-card--cloudy t-dark`]]), false, false, 1));
            }

            getTemplateName() {
                return `89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a`, ``);
            }
        }],
        [26, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <div class="o-rhythm o-rhythm--compact has-big-font-size">
      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`content`, `We’re Cloud Four`], [`level`, 0], [`weight`, `light`]]), false, false, 7));
                this.echo(`      <p>
        We’ve solved complex responsive web design and web development
        challenges for ecommerce, healthcare, fashion, B2B, SAAS and non-profit
        organizations.
      </p>
    </div>
  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Hire our team`], [`href`, `https://cloudfour.com/and-you/`], [`class`, `c-button--primary`]]), false, false, 20));
                this.echo(`  `);
            }

            getTemplateName() {
                return `89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a');

let template = env.loadTemplate('89edea51b751c28ae6fee38e9392724dc6ad8db4838f4defdd1e0eebcbd4440a');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/card/demo/cloudy.twig", args: context }
     );
     return rendered;;
};